import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from 'src/app/services/token.service';
import { SnackBarService } from 'src/app/shared/snack-bar.service';
import { CardRodada } from '../../../components/card-primecap/model/card-interface';
import { Rodada } from 'src/app/domain/primecap/model/rodada';
import { ModalConfirmacaoService } from 'src/app/shared/modal-confirmacao/modal-confirmacao.service';
import { switchMap, take } from 'rxjs/operators';
import { InfoRodada } from '../../../model/interface/info-rodada';
import { StatusCadastroUsuarioEnum } from '../../../model/enum/status-cadastro-usuario.enum';
import { MatDialog } from '@angular/material/dialog';
import { EMPTY } from 'rxjs';
import { RodadasCoreService } from '../../../core/rodadas-core.service';
import { ParametrosPaginacao } from '../../../model/interface/parametros-paginacao';
import { TipoRodadaEnum } from '../../../model/enum/tipo-rodada.enum';
import { MasterService } from '../../layouts/master/master.service';
import { DetalhesService } from '../detalhes/detalhes.service';
import { TipoUsuarioEnum } from '../../../model/enum/tipo-usuario.enum';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  rodadas: Rodada[] = [];
  cardsRodada: CardRodada[] = [];
  cardClass = 'rodadas-card';
  labelBotao: string = 'Quero Investir';
  paginacaoPadrao: ParametrosPaginacao = {
    tamanhoPagina: 100
  }

  constructor(
    private rodadasCoreService: RodadasCoreService,
    private tokenService: TokenService,
    private masterService: MasterService,
    private router: Router,
    private snackBarService: SnackBarService,
    private modalConfirmacaoService: ModalConfirmacaoService,
    public dialog: MatDialog,
    private detalhesRodadaService: DetalhesService
  ) {
    this.masterService.setMenu();
  }

  ngOnInit(): void {
    this.buscarRodadas();

    if (this.tokenService.carregarUsuarioLogado().tipoUsuario == TipoUsuarioEnum.ADMINISTRADOR) {
      this.labelBotao = 'Detalhar';
    }
  }

  buscarRodadas() {
    return this.rodadasCoreService.getRodadasHome(this.paginacaoPadrao).pipe(take(1)).subscribe(
      (res) => {
        this.rodadas = res.dados[0].content,
        this.rodadas.forEach(rodada => {
          this.carregaCards(rodada);
        });
      }
    )
  }

  carregaCards(rodada: Rodada) {
    let cardRodada = new CardRodada();
    cardRodada.banner = rodada.banner;
    cardRodada.logo = rodada.logo;
    cardRodada.valorMinimo = rodada.valorMinimoSucesso;
    cardRodada.valorCaptado = rodada.valorCaptado;
    cardRodada.qtdInvestidores = rodada.quantidadeInvestidores;
    cardRodada.empresaNome = rodada.empresaNome;
    cardRodada.setorNome = rodada.empresaSetor;
    cardRodada.setorCorTag = rodada.empresaSetorCorTag;
    cardRodada.valorRodada = rodada.valor;
    cardRodada.textoCard = rodada.textoCard;
    if (rodada.tipoRodada == TipoRodadaEnum.DIVIDA) {
      cardRodada.participacao = rodada.rentabilidadeOferecida;
    } else if (rodada.tipoRodada == TipoRodadaEnum.EQUITY) {
      cardRodada.participacao = rodada.equityOferecido;
    }
    cardRodada.empresaUuid = rodada.empresaUuid;
    cardRodada.tipoRodada = rodada.tipoRodada;
    cardRodada.rodadaUuid = rodada.uuid;
    this.cardsRodada.push(cardRodada);
  }

  redirecionarDetalhesCard(card: CardRodada) {
    let statusCadastro = this.tokenService.carregarUsuarioLogado()?.statusCadastro;

    switch (statusCadastro) {
      case StatusCadastroUsuarioEnum.ATIVO:
        this.router.navigate([`detalhes/${card.empresaUuid}/${card.rodadaUuid}`]);
        break;
      case StatusCadastroUsuarioEnum.INATIVO:
        this.snackBarService.exibirMensagem('Seu cadastro encontra-se inativo. Entre em contato com a Primecap!', true);
        break;
      case StatusCadastroUsuarioEnum.PENDENTE:
        this.abrirModalConclusaoCadastro();
        break;
    }
  }

  abrirModalConclusaoCadastro(): void {
    const result$ = this.modalConfirmacaoService.mostrarConfirmacao(
      'Concluir Cadastro',
      'Para visualizar as informações dessa rodada você precisa finalizar seu cadastro na primecap.',
      'Ok, finalizar cadastro',
      'Não, obrigado(a)!'
    )
    result$.asObservable().pipe(
      take(1),
      switchMap(async result => result ? this.router.navigateByUrl('/investidor/C') : EMPTY)
    ).subscribe();
  }

  salvarInfoRodada(rodada: CardRodada): void {
    let infoRodada: InfoRodada = {
      'empresaUuid': rodada.empresaUuid,
      'tipoRodada': rodada.tipoRodada,
      'rodadaUuid': rodada.rodadaUuid
    };
    this.detalhesRodadaService.setInfoRodada(infoRodada);
  }
}
